import { useSyncExternalStore } from 'react';

/**
 * `true` abaixo de 768px — espelha o `mobileBreakpoint` do Sidebar do Aluma,
 * para o shell decidir entre sidebar fixa (desktop) e off-canvas (mobile).
 * Sem `useEffect` (preferência do projeto): assinatura via `useSyncExternalStore`.
 */
const MOBILE_QUERY = '(max-width: 767px)';

function subscribe(onChange: () => void) {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => {};
  const mql = window.matchMedia(MOBILE_QUERY);
  mql.addEventListener('change', onChange);
  return () => mql.removeEventListener('change', onChange);
}

function getSnapshot() {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia(MOBILE_QUERY).matches
  );
}

export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
